module.exports = __webpack_public_path__ + "static/img/about4.012728b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about4.jpg
// module id = vJSA
// module chunks = 1